// Should stay in sync with eventTeamRoleAssignmentTypesMap.mjs

import { APPRAISER_ASSIGNMENT_ATM_TYPES } from './AppraiserAssignmentTypes';
import { EVENT_TEAM_ROLE } from './AppraiserEventTeamRoleType';

export const TEAM_ROLE_ASSIGNMENT_TYPES_MAP = [
  {
    role: EVENT_TEAM_ROLE.ISACA,
    assignmentTypes: [APPRAISER_ASSIGNMENT_ATM_TYPES.ISACA_ATMS]
  },
  {
    role: EVENT_TEAM_ROLE.INTERNAL,
    assignmentTypes: [APPRAISER_ASSIGNMENT_ATM_TYPES.INTERNAL_ATMS]
  },
  {
    role: EVENT_TEAM_ROLE.OBSERVATION,
    assignmentTypes: [
      APPRAISER_ASSIGNMENT_ATM_TYPES.INTERNAL_EXTRAS,
      APPRAISER_ASSIGNMENT_ATM_TYPES.ISACA_EXTRAS
    ]
  },
  {
    role: EVENT_TEAM_ROLE.APPRENTICESHIP,
    assignmentTypes: [
      APPRAISER_ASSIGNMENT_ATM_TYPES.INTERNAL_EXTRAS,
      APPRAISER_ASSIGNMENT_ATM_TYPES.ISACA_EXTRAS
    ]
  },
  {
    role: EVENT_TEAM_ROLE.FDA,
    assignmentTypes: [APPRAISER_ASSIGNMENT_ATM_TYPES.FDA_EXTRAS]
  }
];
